import React, { useEffect, useState } from 'react';
import { Flexbox, FlexboxColumn } from '../../components/action/Flexbox';
import { Line } from '../../components/action/Line';
import OTPInput from '../../components/action/OTPInput';
import TwitterButton from '../../components/action/TwitterButton';
import ButtonApi from '../../components/ButtonApi';
import ThemedText from '../../components/theme/ThemedText';
import ThemeLogo from '../../components/theme/ThemeLogo';
import { useBackendApi } from '../../helpers/backendHelper';
import { useGlobalState } from '../../state/GlobalStateProvider';
import { trackClairtyEvent } from '../../utils';
import './InviteWrapper.scss';
import Puzzle from './Puzzle/Puzzle';

const InviteWrapper = ({ children, eligibileProtocols }) => {
  const [{ user }] = useGlobalState();
  const [isInvited, setIsInvited] = useState();
  const [openPuzzle, setOpenPuzzle] = useState(false);
  const [otp, setOtp] = useState();
  const backendHelper = useBackendApi();

  async function openTweetIntent() {
    try {
      
      trackClairtyEvent('get_code', {
        type: 'ask_x',
      });

      const response = await backendHelper.reviews.randomTwitterCodeUser();

      const tweetText = encodeURIComponent(`GMerc @${response?.data?.twitterUsername}, need invite code for Onion Takes by @0xmercle. 
Help a fellow degen & gods of trenches will bless you.`);

      const tweetUrl = `https://twitter.com/intent/tweet?text=${tweetText}`;
      window.open(tweetUrl, '_blank');
    } catch (error) {}
  }

  async function handleOtp() {
    if (otp.length < 6) return alert.error('Enter Code');
    try {
      const body = {
        code: otp,
      };

      await backendHelper.reviews.postMegaCode(body);

      trackClairtyEvent('try_code', {
        code: otp,
        response: 'pass',
        page: 'post_take',
      });

      setIsInvited(true);
    } catch (error) {
      setIsInvited(false);

      trackClairtyEvent('try_code', {
        code: otp,
        response: 'incorrect',
        page: 'post_take',
      });
      console.log('error is Postmegacode', error);
      alert.error('Invalid Code');
    }
  }

  async function checkCodeInvite() {
    try {
      if ([...(eligibileProtocols || [])].length > 0) {
        return setIsInvited(true);
      }
      const data = await backendHelper.reviews.useMegaCode();
      if (data.data.inviteCodes?.length > 0 || data.data.megaCodes?.length > 0) {
        return setIsInvited(true);
      }
      setIsInvited(false);
    } catch (error) {
      setIsInvited(false);
      console.log('error is checking invite code', error);
    }
  }

  function handlePuzzle() {

    trackClairtyEvent('get_code', {
      type: 'solve_puzzle',
    });

    setOpenPuzzle(!openPuzzle);
  }

  useEffect(() => {
    checkCodeInvite();
  }, []);

  if (isInvited === undefined)
    return (
      <FlexboxColumn className='invite_wrapper' gap='3rem' justifyContent='flex-start'>
        <span className='invite_wrapper_loader'></span>
      </FlexboxColumn>
    );

  if (isInvited) return children;
  return (
    <>
      {openPuzzle ? (
        <Puzzle setOtp={setOtp} handleOtp={setIsInvited} handlePuzzle={() => setOpenPuzzle(false)} />
      ) : (
        <FlexboxColumn className='invite_wrapper' gap='3rem' justifyContent='flex-start'>
          <FlexboxColumn gap='0.75rem'>
            <ThemedText.H2>
              Welcome to <b>OnionTakes</b>
            </ThemedText.H2>
            <ThemedText.P>
              OnionTakes delivers bold, unfiltered feedback—layered like an onion. We connect real users with protocol builders by peeling away the noise and revealing what truly
              matters.
            </ThemedText.P>
          </FlexboxColumn>

          <FlexboxColumn>
            <ThemedText.P>Enter your invite code to enter OnionTakes</ThemedText.P>

            <Flexbox gap='1.5rem'>
              <OTPInput length={6} onChange={setOtp} />
              <ButtonApi className='invite_wrapper_submit_button' onClick={handleOtp}>
                <ThemedText.H5>Submit</ThemedText.H5>
              </ButtonApi>
            </Flexbox>
          </FlexboxColumn>
          <Line />
          <FlexboxColumn>
            <ThemedText.P>Don’t have an invite code? Try you luck here.</ThemedText.P>
            <Flexbox className='invite_wrapper_button_wrapper'>
              <TwitterButton onClick={openTweetIntent}>
                <ThemeLogo icon={'twitterLogo'} />
                <ThemedText.H5>Ask for code</ThemedText.H5>
              </TwitterButton>
              <ButtonApi className='invite_wrapper_puzzle_button' onClick={handlePuzzle}>
                <svg width='16' height='15' viewBox='0 0 29 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M12.3184 17.5111L11.1167 16.3095L12.2717 15.1545C12.61 14.8161 12.61 14.2561 12.2717 13.9178C11.9334 13.5795 11.3734 13.5795 11.035 13.9178L9.88004 15.0728L8.76004 13.9528C8.4217 13.6145 7.8617 13.6145 7.52337 13.9528C7.18504 14.2911 7.18504 14.8511 7.52337 15.1895L8.64337 16.3095L7.48837 17.4645C7.15004 17.8028 7.15004 18.3628 7.48837 18.7011C7.66337 18.8761 7.88504 18.9578 8.1067 18.9578C8.32837 18.9578 8.55004 18.8761 8.72504 18.7011L9.88004 17.5461L11.0817 18.7478C11.2567 18.9228 11.4784 19.0045 11.7 19.0045C11.9217 19.0045 12.1434 18.9228 12.3184 18.7478C12.6567 18.4095 12.6567 17.8495 12.3184 17.5111Z'
                    fill='white'
                  />
                  <path
                    d='M16.2967 17.4993C15.6551 17.4993 15.1184 16.9743 15.1184 16.3327C15.1184 15.691 15.6317 15.166 16.2734 15.166H16.2967C16.9384 15.166 17.4634 15.691 17.4634 16.3327C17.4634 16.9743 16.9501 17.4993 16.2967 17.4993Z'
                    fill='white'
                  />
                  <path
                    d='M20.8934 17.4993C20.2518 17.4993 19.7151 16.9743 19.7151 16.3327C19.7151 15.691 20.2284 15.166 20.8701 15.166H20.8934C21.5351 15.166 22.0601 15.691 22.0601 16.3327C22.0601 16.9743 21.5468 17.4993 20.8934 17.4993Z'
                    fill='white'
                  />
                  <path
                    d='M18.5834 19.7981C17.9417 19.7981 17.4167 19.2848 17.4167 18.6431V18.6198C17.4167 17.9781 17.9417 17.4531 18.5834 17.4531C19.2251 17.4531 19.7501 17.9781 19.7501 18.6198C19.7501 19.2615 19.2367 19.7981 18.5834 19.7981Z'
                    fill='white'
                  />
                  <path
                    d='M18.5834 15.2024C17.9417 15.2024 17.4167 14.6891 17.4167 14.0474V14.0241C17.4167 13.3824 17.9417 12.8574 18.5834 12.8574C19.2251 12.8574 19.7501 13.3824 19.7501 14.0241C19.7501 14.6658 19.2367 15.2024 18.5834 15.2024Z'
                    fill='white'
                  />
                  <path
                    opacity='0.4'
                    d='M26.1666 12.9155V19.4255C26.1666 22.8672 23.3666 25.6672 19.9249 25.6672H9.07492C5.63325 25.6672 2.83325 22.8672 2.83325 19.4255V12.9155C2.83325 9.47383 5.63325 6.67383 9.07492 6.67383H19.9249C23.3666 6.67383 26.1666 9.47383 26.1666 12.9155Z'
                    fill='white'
                  />
                  <path
                    d='M16.4133 3.16232L16.4017 4.25898C16.39 5.28565 15.5383 6.13732 14.5 6.13732C14.325 6.13732 14.22 6.25398 14.22 6.40565C14.22 6.55732 14.3367 6.67398 14.4883 6.67398H12.61C12.5983 6.59232 12.5867 6.49898 12.5867 6.40565C12.5867 5.35565 13.4383 4.50398 14.4767 4.50398C14.6517 4.50398 14.7683 4.38732 14.7683 4.23565L14.78 3.13898C14.7917 2.69565 15.1533 2.33398 15.5967 2.33398H15.6083C16.0633 2.33398 16.4133 2.70732 16.4133 3.16232Z'
                    fill='white'
                  />
                </svg>

                <ThemedText.H5>Solve this puzzle</ThemedText.H5>
              </ButtonApi>
            </Flexbox>
          </FlexboxColumn>
        </FlexboxColumn>
      )}
    </>
  );
};

export default InviteWrapper;
